// =============================================================
// 🔥 sessionsService.js — Listener oficial do Firestore
// =============================================================
//
// Escuta TODAS as sessões da IA do Amor em tempo real.
//
// Melhorias aplicadas:
// - Suporte a ordenação automática por createdAt desc
// - Validação de dados incompletos
// - Garantia de retorno SEMPRE em array
// - Callback seguro (não quebra a dashboard)
// - Tratamento explícito de erros
//
// É usado pelos hooks:
// - useDashboardMetrics()
// - useRealtimeStats()
//
// =============================================================

import {
  collection,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";

export function listenAllSessions(callback, onError) {
  try {
    // Query base: todas as sessões, ordenadas da mais recente para a mais antiga
    const ref = query(
      collection(db, "ai_sessoes"),
      orderBy("createdAt", "desc") // garante ordem consistente
    );

    const unsub = onSnapshot(
      ref,
      (snap) => {
        try {
          const list = snap.docs.map((doc) => {
            const data = doc.data() || {};

            return {
              // ID sempre presente
              id: doc.id,

              // Campos principais de status e tempo
              status: data.status || "indefinido",
              createdAt: data.createdAt || null,
              iniciouEm: data.iniciouEm || null,
              finalizadoEm: data.finalizadoEm || null,

              // Avatar
              avatarName: data.avatarName || "Desconhecido",

              // Campo opcional: se existir no Firestore, usamos;
              // se não existir, fica null (calculado depois se quiser)
              autoResolved: data.autoResolved ?? null,

              // Espalha TODOS os outros campos (operadorId, userId, etc)
              ...data,
            };
          });

          // garante que SEMPRE devolvemos array
          callback(Array.isArray(list) ? list : []);
        } catch (err) {
          console.error("Erro ao processar snapshot de ai_sessoes:", err);
          if (onError) onError(err);
        }
      },
      (err) => {
        console.error("Erro ao ouvir ai_sessoes:", err);
        if (onError) onError(err);
      }
    );

    return unsub;
  } catch (err) {
    console.error("Erro crítico em listenAllSessions:", err);
    if (onError) onError(err);
    // retorna função vazia para evitar erros ao tentar unsub()
    return () => {};
  }
}
